import { createReducer } from '@reduxjs/toolkit';
import { messengerSettingsActions as actions } from './messengerSettings.actions';
const makeTranslatedString = (translatedMap = {}) => ({
    translatedMap,
    maxLength: 50,
});
const mkConnectedState = (companyId, enabled, findArticles = makeTranslatedString(), searchBarPlaceholder = makeTranslatedString(), displayType = 'display-button-for-access-to-articles') => ({
    type: 'connected',
    companyId,
    enabled,
    displayType,
    translations: {
        findArticles,
        searchBarPlaceholder,
    },
});
const initialState = {
    selectedLanguage: 'en',
    elevioIntegration: {
        type: 'not-connected',
    },
    pristineElevioIntegration: {
        type: 'not-connected',
    },
};
export const messengerSettingsReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.initialize, (state, action) => {
        const settings = action.payload;
        const elevioIntegration = settings.integrations.elevio !== undefined
            ? mkConnectedState(settings.integrations.elevio.companyId, settings.integrations.elevio.enabled, makeTranslatedString(settings.general.findArticles), makeTranslatedString(settings.integrations.elevio.searchBarPlaceholder), settings.integrations.elevio.displayType)
            : {
                type: 'not-connected',
            };
        state.pristineElevioIntegration = elevioIntegration;
        state.elevioIntegration = elevioIntegration;
    })
        .addCase(actions.reset, (state) => {
        return Object.assign(Object.assign({}, initialState), { pristineElevioIntegration: state.pristineElevioIntegration, elevioIntegration: state.pristineElevioIntegration });
    })
        .addCase(actions.setElevioCompanyId, (state, action) => {
        if (state.elevioIntegration.type === 'not-connected') {
            state.elevioIntegration = mkConnectedState(action.payload, true);
        }
        else {
            state.elevioIntegration.companyId = action.payload;
        }
    })
        .addCase(actions.toggleElevioIntegration, (state) => {
        if (state.elevioIntegration.type === 'connected') {
            state.elevioIntegration.enabled = !state.elevioIntegration.enabled;
        }
    })
        .addCase(actions.updateDisplayType, (state, action) => {
        if (state.elevioIntegration.type !== 'not-connected') {
            state.elevioIntegration.displayType = action.payload;
        }
    })
        .addCase(actions.changeSelectedLanguage, (state, action) => {
        state.selectedLanguage = action.payload;
    })
        .addCase(actions.updateTranslatedString, (state, action) => {
        if (state.elevioIntegration.type !== 'not-connected') {
            const { translatable, language, value } = action.payload;
            state.elevioIntegration.translations[translatable].translatedMap[language] = value;
        }
    });
});
